export type AppRelease={version:string;url:string};
const origin='https://skrepka.myxa.tv';
// Published together with the installer. The manifest enables future releases
// to notify already running windows without replacing their chat session.
export const bundledRelease:AppRelease={version:'0.1.6',url:origin+'/downloads/SkrepkaChat-0.1.6-Setup.exe'};
export function versionParts(value:string):number[]|null {
  return /^(0|[1-9]\d{0,5})\.(0|[1-9]\d{0,5})\.(0|[1-9]\d{0,5})$/.test(value)?value.split('.').map(Number):null;
}
export function newerVersion(latest:string,installed:string):boolean {
  const a=versionParts(latest),b=versionParts(installed);
  if(!a||!b)return false;
  for(let i=0;i<3;i++){if(a[i]!==b[i])return a[i]>b[i];}
  return false;
}
export function parseRelease(value:unknown):AppRelease|null {
  if(!value||typeof value!=='object')return null;
  const v=value as Record<string,unknown>;
  if(typeof v.version!=='string'||!versionParts(v.version))return null;
  const url=origin+`/downloads/SkrepkaChat-${v.version}-Setup.exe`;
  return v.url===url?{version:v.version,url}:null;
}
export async function latestRelease():Promise<AppRelease> {
  try{
    const response=await fetch('/downloads/skrepka-chat-latest.json',{cache:'no-store',credentials:'omit',signal:AbortSignal.timeout(5000)});
    if(!response.ok)return bundledRelease;
    const release=parseRelease(await response.json());
    return release&&newerVersion(release.version,bundledRelease.version)?release:bundledRelease;
  }catch{return bundledRelease;}
}
